import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=23e13792"
import script from "./SocialShare.vue?vue&type=script&lang=js"
export * from "./SocialShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e13792')) {
      api.createRecord('23e13792', component.options)
    } else {
      api.reload('23e13792', component.options)
    }
    module.hot.accept("./SocialShare.vue?vue&type=template&id=23e13792", function () {
      api.rerender('23e13792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/SocialShare.vue"
export default component.exports